import { MINCOL } from "../../../constants/const"

export const eiuHeader = [
    {accessor: 'id',
    Header: 'ID'},
    {accessor: 'eiu',
    Header: 'Bezeichnung',
    width: '25em'},
    {accessor: 'kurz',
    Header: 'Abkürzung',
    width: MINCOL},
]

export const eiuInputs = ['eiu', 'kurz']